import React, { useEffect, useState } from "react";
import { Select, Row, Col, Button } from "antd";
import "./LangindList.css";
import { setCaption } from "../../../../common/redux/actions/interfaceActions";
import { useDispatch, useSelector } from "react-redux";
import LandingTable from "../../components/LandingList/LandingTable";
import {
  getLandingList,
  getStopsList,
  updateLandingList
} from "../../redux/actions/landingListAction";
import Sidebar from "../../components/LandingList/Sidebar";
import { getOrderById } from "../../../Executorship/Order/redux/actions/orderCard";
import Footer from "../../../../common/hoc/withFooter";

const LandingList = ({ match, history }) => {
  const dispatch = useDispatch();
  const orderId = match.params.id;
  const [listAction, setListAction] = useState(null);
  const [selectedStop, setSelectedStop] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const order = useSelector(state => state.Executorship.Orders.orderCard.data);
  const personsData = useSelector(state => state.Lists.landingList.persons);
  const stopsList = useSelector(state => state.Lists.landingList.stops);
  const tableLoading = useSelector(
    state => state.Lists.landingList.tableLoading
  );
  const driver = order && order.driver;
  const driverId = order && order.driverId;
  const vehicleId = order && order.vehicleId;
  const vehicle = order && order.vehicle;
  const responsible =
    order &&
    order.responsible
  const responsibleId =
    order &&
    order.responsible &&
    order.responsible.profileId;

  const orderStatusName = order && order.orderStatusName;
  const arrivalDatetime = order && order.arrivalDatetime;

  useEffect(() => {
    initCaption();
  }, [order]);

  useEffect(() => {
    dispatch(getOrderById(orderId));
    dispatch(getLandingList(orderId, null, null));
  }, [orderId]);

  useEffect(() => {
    if (order) {
      dispatch(getStopsList(order.requestId));
    }
  }, [order]);

  const initCaption = () => {
    const orderNumber =
      order &&
      order.number &&
      order.number.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, `$1 `);

    dispatch(
      setCaption({
        enabled: true,
        mainCaption: "Список посадки и высадки пассажиров в пром. пунктах",
        breadCrumbs: [
          {
            path: "/control-panel",
            breadcrumbName: "Панель управления"
          },
          { path: "/executorship/order", breadcrumbName: "Исполнительство" },
          {
            path: "/executorship/order/" + orderId,
            breadcrumbName: "Заказ - " + orderNumber
          }
        ]
      })
    );
  };

  const changeTable = (pagination, _, sorter) => {
    dispatch(getLandingList(orderId, pagination, sorter));
  };

  const updateLanding = () => {
    dispatch(
      updateLandingList({ orderId, listAction, selectedStop, selectedRows })
    );
  };

  const changePageSize = pages => {
    const pagination = {
      pageSize: pages && parseInt(pages),
      total: personsData.total,
      current: personsData.current_page
    };
    dispatch(getLandingList(orderId, pagination, null));
  };

  const goBack = () => {
    history.goBack()
  }

  return (
    <div className={"site-wrapper"}>
      <Row gutter={16} className={"landing-cols"}>
        <Col span={18}>
          <LandingTable
            data={personsData}
            routes={stopsList}
            onChange={changeTable}
            changePageSize={changePageSize}
            loading={tableLoading}
            setSelectedRows={setSelectedRows}
          />
        </Col>
        <Col span={6}>
          <Sidebar
            personCount={personsData.data.length}
            driver={{ driver, driverId }}
            vehicle={{ vehicleId, vehicle }}
            responsible={{ ...responsible, responsibleId }}
            orderStatusName={orderStatusName}
            arrivalDatetime={arrivalDatetime}
            goBack={goBack}
          />
        </Col>
      </Row>
      <Footer className={"landing-footer"}>
        <Select
          className={"landing-footer__select"}
          placeholder={"Выберите действие"}
          onChange={value => {
            setListAction(value);
          }}
        >
          <Select.Option value={1}>Добавить посадку</Select.Option>
          <Select.Option value={2}>Добавить высадку</Select.Option>
          <Select.Option value={3}>Убрать посадку</Select.Option>
          <Select.Option value={4}>Убрать высадку</Select.Option>
        </Select>
        <Select
          className={"landing-footer__select"}
          placeholder={"Выберите пром. пункт"}
          onChange={id => {
            setSelectedStop(id);
          }}
        >
          {stopsList &&
            stopsList.map(route => {
              if (
                route.route_point_type_id !== 1 &&
                route.route_point_type_id !== 3
              ) {
                return (
                  <Select.Option key={route.route_id} value={route.route_id}>
                    {route.route}
                  </Select.Option>
                );
              } else {
                return null;
              }
            })}
        </Select>
        <Button
          type="primary"
          ghost
          disabled={!selectedStop && !listAction}
          className={"landing-footer__button"}
          onClick={updateLanding}
        >
          Подтвердить
        </Button>
      </Footer>
    </div>
  );
};

export default LandingList;
